export default {"src":"/_next/static/media/check_icon.38c657f3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};